export const breakpoints = Object.freeze({
  EVENTYPE: 800,
  CREATED: 500,
});
